import React from "react";
import { UgaK12Identifier } from "../../../assets/icons/index";
import { UGA_EXTERNAL_SOURCE_TYPE_ID } from "../../screen/questions/constants";

export interface IUgaItemIconProps {
  externalSourceTypeId?: number;
  /** Rendered width in px; height keeps the SVG's 25:33 aspect ratio. */
  size?: number;
  className?: string;
}

const UGA_LABEL = "UGA K-12 Assessment Solutions Item Bank";

function UgaItemIcon({
  externalSourceTypeId,
  size = 16,
  className,
}: IUgaItemIconProps) {
  if (externalSourceTypeId !== UGA_EXTERNAL_SOURCE_TYPE_ID) {
    return null;
  }

  return (
    <span
      className={className}
      role="img"
      aria-label={UGA_LABEL}
      title={UGA_LABEL}
      style={{ display: "inline-flex", lineHeight: 0 }}
    >
      <UgaK12Identifier width={size} height={(size * 33) / 25} />
    </span>
  );
}

export default UgaItemIcon;
